import DamuTermsFileKK from 'assets/files/damu-loan_terms-kk.pdf'
import DamuTermsFileRU from 'assets/files/damu-loan_terms-ru.pdf'
import OwnTermsFileKK from 'assets/files/own-loan_terms-kk.pdf'
import OwnTermsFileRU from 'assets/files/own-loan_terms-ru.pdf'
import InfoIcon from 'assets/icons/landing/info.svg?component'
import Clock from 'assets/images/landing/clock.svg?component'
import Discount from 'assets/images/landing/discount.svg?component'
import PdfIcon from 'assets/images/landing/pdf.svg?component'
import Sandwatch from 'assets/images/landing/sandwatch.svg?component'
import Suitcase from 'assets/images/landing/suitcase.svg?component'
import Tenge from 'assets/images/landing/tenge.svg?component'
import BodyText from 'components/UI/Landing/body-text'
import OutlinedButton from 'components/UI/Landing/button-outlined'
import { useTranslation } from 'react-i18next'
import tw from 'twin.macro'
import { gradiendBorderStyles } from 'utils/constants'

import { Funds } from './section-terms.view'
import TermsCard from './terms-card.view'
import TermsCardWithTabs from './terms-card-with-tabs.view'

export const getMoreInfoLinks = (fund: Funds, lang: string) => {
  if (fund === 'freedom') {
    if (lang === 'ru') return OwnTermsFileRU
    else if (lang === 'kk') return OwnTermsFileKK
  } else if (fund === 'damu') {
    if (lang === 'ru') return DamuTermsFileRU
    else if (lang === 'kk') return DamuTermsFileKK
  }
}

const TermCards = ({ fund, onFundChange }: { fund: Funds; onFundChange: (fund: Funds) => void }) => {
  const {
    t,
    i18n: { language }
  } = useTranslation('landing')

  return (
    <div className='grid grid-cols-1 grid-rows-7 gap-y-4 mt-4 lg:mt-10 lg:grid-cols-8 lg:gap-5'>
      <TermsCardWithTabs
        key={fund}
        fund={fund}
        twStyle={tw`order-1 lg:order-2 lg:col-span-4 lg:row-span-4`}
        onFundChange={onFundChange}
      />
      <TermsCard
        icon={<Discount />}
        subtitle={fund === 'freedom' ? t('loan-terms.rate-card.title') : t('loan-terms.rate-card.gsv')}
        primaryText={
          fund === 'damu'
            ? '23,4%'
            : t('interpolations.interest-rate-between', { ns: 'common', fromRate: '20', toRate: '35' })
        }
        subtitle2={fund === 'freedom' ? t('loan-terms.rate-card.gsv') : t('loan-terms.rate-card.gsv-damu')}
        primaryText2={
          fund === 'freedom'
            ? t('interpolations.interest-rate-between', { ns: 'common', fromRate: '21,8', toRate: '46' })
            : t('interpolations.interest-rate-between', { ns: 'common', fromRate: '7', toRate: '8' })
        }
        twStyle={[tw`order-2 lg:order-3 lg:col-span-2`, fund === 'damu' ? tw`lg:row-span-4` : tw`row-span-6`]}
        note={fund === 'damu' ? null : t('loan-terms.rate-card.freedom-warning')}
      />
      <TermsCard
        icon={<Suitcase />}
        subtitle={t('loan-terms.members-card.title')}
        primaryText={t('loan-terms.members-card.text')}
        twStyle={tw`order-3 lg:order-1 lg:col-span-2 lg:row-span-4`}
      />
      <TermsCard
        icon={<Clock />}
        subtitle={t('loan-terms.age-card.title')}
        primaryText={t('loan-terms.age-card.age-limit')}
        twStyle={tw`order-4 lg:col-span-2 lg:row-span-3`}
      />
      <TermsCard
        icon={<Sandwatch />}
        subtitle={t('loan-terms.business-requirements.title')}
        primaryText={t(`loan-terms.business-requirements.${fund === 'damu' ? 'textDamu' : 'text'}`, {
          count: fund === 'damu' ? 12 : 1
        })}
        twStyle={tw`order-5 lg:col-span-2 lg:row-span-3`}
      />
      <TermsCard
        icon={<Tenge />}
        subtitle={t('loan-terms.currency-card.title')}
        primaryText={t('loan-terms.currency-card.currency')}
        twStyle={tw`order-6 lg:col-span-2 lg:row-span-3`}
      />
      <div
        css={[
          tw`flex flex-col gap-5 relative order-7 lg:col-span-2`,
          fund === 'damu' ? tw`lg:row-span-3 ` : tw`lg:row-span-1`
        ]}
      >
        {fund === 'damu' && (
          <div
            css={[
              tw`relative flex flex-1 items-center gap-x-3 gap-y-2 bg-[var(--bg-landing-card)] p-4 lg:p-6 md:items-start md:flex-col rounded-[20px] text-[var(--text-landing-muted)]`,
              gradiendBorderStyles
            ]}
          >
            <InfoIcon />
            <BodyText text={t('loan-terms.scoring-text')} className='text-[12px] leading-[140%]' />
          </div>
        )}
        <a className='w-full' target='_blank' href={getMoreInfoLinks(fund, language)} rel='noreferrer'>
          <OutlinedButton className='flex items-center justify-center  font-semibold  w-full gap-2 border-[var(--text-landing-green)] text-[var(--text-landing-green)] hover:bg-gradient-to-r hover:text-[white] transition-all duration-300 from-green-dark-landing to-green-light-landing'>
            <PdfIcon />
            {t('loan-terms.more-btn')}
          </OutlinedButton>
        </a>
      </div>
    </div>
  )
}

export default TermCards
